/* LUKE 20260820: reliable-delivery consolidation. theme.liquid <script> tags were being
   dropped by Shopify page cache on many renders; custom.js is always served, so the
   swipe->color sync + cart-thumbnail override + disable-flags live here now. */
try{window.__obiwanMobileColorThumbExact20260527Light=true;window.__obiwanVariantOptionsNavyGallery20260502=true;window.__obiwanInitialVariantGallerySync20260506=true;window.__bbqCarouselVariantSyncV3=true;window.__obiwanBbq22FinalHandleDotSync20260528=true;window.__obiwanMainProductVariantGallerySync20260506=true;window.__obiwanLayoutVariantGallerySync20260506=true;}catch(e){}

/* OBIWAN_BBQ_KLAVIYO_KILL_SWITCH_20260605: Tom requested quiz/email capture OFF due sales dive. Blocks cached old 8-sec snippets. */
(function(){
  window.__obiwanBbqKlaviyo8SecTest20260604 = true;
  window.__obiwanBbqKlaviyo8SecTestInline20260604 = true;
  window.__obiwanBbqKlaviyo8SecCarouselAsset20260604 = true;
  window.__obiwanBbqKlaviyo8SecScriptTag20260604 = true;
  var BLOCK_FORM_ID = 'Y6TJDr';
  function shouldBlock(args){
    try { return args && args[0] === 'openForm' && args[1] === BLOCK_FORM_ID; } catch(e) { return false; }
  }
  function patchQueue(q){
    if (!q || q.__obiwanBbqKlaviyoKillSwitch20260605) return q;
    var oldPush = q.push;
    q.push = function(){
      if (shouldBlock(arguments[0])) return q.length;
      return oldPush.apply(q, arguments);
    };
    q.__obiwanBbqKlaviyoKillSwitch20260605 = true;
    return q;
  }
  window._klOnsite = patchQueue(window._klOnsite || []);
})();
/* /OBIWAN_BBQ_KLAVIYO_KILL_SWITCH_20260605 */


// Neutralize Cozy Anti-Theft copy protection
(function() {
  // Remove the protect.js script entirely
  var scripts = document.querySelectorAll('script[src]');
  for (var i = 0; i < scripts.length; i++) {
    if (scripts[i].src.indexOf('cozyantitheft') !== -1 || scripts[i].src.indexOf('protect.js') !== -1) {
      scripts[i].remove();
    }
  }
  
  // Override addEventListener to prevent future copy/cut blocking
  var origAdd = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function(type, fn, opts) {
    if (type === 'copy' || type === 'cut' || type === 'contextmenu' || type === 'selectstart') {
      return; // Don't register these listeners
    }
    return origAdd.call(this, type, fn, opts);
  };
  
  // Remove any existing copy/contextmenu handlers
  document.oncopy = null;
  document.oncut = null;
  document.oncontextmenu = null;
  document.onselectstart = null;
  document.body && (document.body.oncopy = null);
  document.body && (document.body.oncut = null);
  document.body && (document.body.oncontextmenu = null);
  document.body && (document.body.onselectstart = null);
})();


// Remove copy protection - override user-select: none
(function() {
  function enableSelection() {
    document.body.style.setProperty('user-select', 'text', 'important');
    document.body.style.setProperty('-webkit-user-select', 'text', 'important');
    document.body.style.setProperty('-moz-user-select', 'text', 'important');
    document.body.style.setProperty('-ms-user-select', 'text', 'important');
    document.body.style.setProperty('-webkit-touch-callout', 'default', 'important');
    
    // Also remove the offending style tag
    var styles = document.querySelectorAll('style');
    for (var i = 0; i < styles.length; i++) {
      if (styles[i].textContent.indexOf('user-select: none') !== -1 && 
          styles[i].textContent.indexOf('body') !== -1 &&
          styles[i].textContent.length < 300) {
        styles[i].remove();
        break;
      }
    }
  }
  
  // Run immediately and also after DOM is ready
  enableSelection();
  document.addEventListener('DOMContentLoaded', enableSelection);
  window.addEventListener('load', enableSelection);
})();


// Show selected variant value next to option labels ("Color: Navy", "Size: XS")
(function() {
  function updateOptionLabels() {
    document.querySelectorAll('.product-form__input--pill').forEach(function(fieldset) {
      var legend = fieldset.querySelector('legend.form__label');
      if (!legend) return;
      
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      
      // Get the base option name (Color or Size)
      var baseName = legend.getAttribute('data-option-name');
      if (!baseName) {
        // First run — store the original name
        var text = legend.childNodes[0];
        if (text && text.nodeType === 3) {
          baseName = text.textContent.trim();
        } else {
          baseName = legend.textContent.split('Size Chart')[0].trim();
        }
        legend.setAttribute('data-option-name', baseName);
      }
      
      // Find or create the value span
      var valueSpan = legend.querySelector('.selected-option-value');
      if (!valueSpan) {
        valueSpan = document.createElement('span');
        valueSpan.className = 'selected-option-value';
        valueSpan.style.fontWeight = '400';
        // Insert after the base text node
        var firstChild = legend.childNodes[0];
        if (firstChild && firstChild.nodeType === 3) {
          firstChild.textContent = baseName + ': ';
          firstChild.after(valueSpan);
        } else {
          legend.prepend(valueSpan);
        }
      }
      
      valueSpan.textContent = checked.value;
    });
  }
  
  // Run on page load
  updateOptionLabels();
  
  // Run when any radio button changes
  document.addEventListener('change', function(e) {
    if (e.target.type === 'radio' && e.target.closest('.product-form__input')) {
      updateOptionLabels();
    }
  });
  
  // Also observe DOM changes (for variant switches that update the form)
  var observer = new MutationObserver(function() {
    updateOptionLabels();
  });
  
  var form = document.querySelector('.product-form');
  if (form) {
    observer.observe(form, { childList: true, subtree: true, attributes: true });
  }
})();


/* OBIWAN_PRODUCT_RELATED_SIX_AND_SWATCH_SYNC_20260502: fill related grid to 6 non-best-sellers and sync color swatches to matching mockup. */
(function(){
  var banned=['dilf-damn-i-love-fire-t-shirt','14-hours-afraid-of-commitment-t-shirt','brisket-worth-losing-sleep-t-shirt','i-turn-dead-animals-into-art-t-shirt','if-god-didnt-want-us-to-eat-whole-hog-t-shirt','itll-be-done-t-shirt','adulting-is-hard-t-shirt','alarm-set-3am-on-purpose-t-shirt-1'];
  function norm(s){return (s||'').toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,' ').trim();}
  function handleFromHref(h){var m=(h||'').match(/\/products\/([^?/#]+)/);return m&&m[1];}
  function currentHandle(){return handleFromHref(location.pathname)||'';}
  function relatedRoot(){var h=Array.from(document.querySelectorAll('h1,h2,h3')).find(function(x){return (x.textContent||'').indexOf('More Pitmaster Worthy Shirts')>-1 || (x.textContent||'').indexOf('Pitmasters Also Bought')>-1;});return h&&(h.closest('section,.shopify-section,product-recommendations')||h.parentElement);}
  function productCardHTML(p){var img=p.images&&p.images[0]?p.images[0].src:'';var price=p.variants&&p.variants[0]?p.variants[0].price:'29.99';return '<li class="grid__item obiwan-related-fill"><div class="card-wrapper product-card-wrapper underline-links-hover"><div class="card card--standard card--media"><div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;"><div class="card__media"><div class="media media--transparent media--hover-effect">'+(img?'<img src="'+img+'" alt="'+p.title.replace(/"/g,'&quot;')+'" loading="lazy" width="533" height="533">':'')+'</div></div></div><div class="card__content"><div class="card__information"><h3 class="card__heading h5"><a href="/products/'+p.handle+'" class="full-unstyled-link">'+p.title+'</a></h3><div class="card-information"><span class="caption-large light"></span><div class="price"><div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span><span class="price-item price-item--regular">From $'+price+'</span></div></div></div></div></div></div></div></div></li>';}
  function fixRelated(){var root=relatedRoot(); if(!root)return; var grid=root.querySelector('ul.grid, .product-grid'); if(!grid)return;
    var cards=Array.from(grid.querySelectorAll('li.grid__item')).filter(function(li){return li.querySelector('a[href*="/products/"]');}); var cur=currentHandle();
    cards.forEach(function(li){var h=handleFromHref((li.querySelector('a[href*="/products/"]')||{}).href); if(!h||h===cur||banned.indexOf(h)>-1)li.remove();});
    cards=Array.from(grid.querySelectorAll('li.grid__item')).filter(function(li){return li.querySelector('a[href*="/products/"]');}); if(cards.length>=6)return;
    fetch('/collections/all-products-2/products.json?limit=250').then(function(r){return r.json();}).then(function(data){var used={}; Array.from(grid.querySelectorAll('a[href*="/products/"]')).forEach(function(a){var h=handleFromHref(a.href); if(h)used[h]=true;}); var html=''; (data.products||[]).some(function(p){if(grid.querySelectorAll('li.grid__item').length>=6)return true; if(!p||!p.handle||p.handle===cur||used[p.handle]||banned.indexOf(p.handle)>-1)return false; used[p.handle]=true; html+=productCardHTML(p); grid.insertAdjacentHTML('beforeend', productCardHTML(p)); return false;});});
  }
  function isColorControl(el){if(!el||el.type!=='radio')return false;var fs=el.closest('fieldset'), legend=fs&&fs.querySelector('legend,.form__label');return norm(el.name).indexOf('color')>-1||norm(el.id).indexOf('color')>-1||norm(legend&&legend.textContent).indexOf('color')>-1;}
  function selectedColor(el){var label=el.id&&document.querySelector('label[for="'+CSS.escape(el.id)+'"]');return (el.value||(label&&label.textContent)||'').replace(/Variant sold out or unavailable/g,'').trim();}
  function mediaAlt(btn){var img=btn&&(btn.querySelector('img')||document.querySelector('#'+CSS.escape(btn.getAttribute('aria-controls')||'')+' img'));return img?(img.alt||''):'';}
  function syncGalleryToColor(color){var c=norm(color);if(!c)return false;var buttons=Array.from(document.querySelectorAll('button.thumbnail,.thumbnail-list button,slider-component button[aria-controls],media-gallery button[aria-controls]'));var hit=buttons.find(function(btn){var a=norm(mediaAlt(btn));return a.endsWith(' '+c)||a.indexOf(c)>-1;});if(hit){hit.click();return true;}return false;}
  function removeLeakedCssText(){try{var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT),n,kill=[];while(n=w.nextNode()){if(n.nodeValue&&n.nodeValue.indexOf('OBIWAN_FEATURED_COLLECTION_VIEWALL_CASE_SPACING_20260502')>-1)kill.push(n);}kill.forEach(function(t){t.nodeValue='';});}catch(e){}}
  function run(){removeLeakedCssText(); /* 20260617: do not mutate Pitmasters Also Bought grid; Liquid owns best-seller list. */}
  document.addEventListener('change',function(e){if(isColorControl(e.target)&&e.target.checked)setTimeout(function(){syncGalleryToColor(selectedColor(e.target));},80);},true);
  document.addEventListener('click',function(e){var lab=e.target.closest&&e.target.closest('label[for]');if(lab){var el=document.getElementById(lab.getAttribute('for'));if(isColorControl(el))setTimeout(function(){syncGalleryToColor(selectedColor(el));},120);}},true);
  document.addEventListener('DOMContentLoaded',run);document.addEventListener('shopify:section:load',run);setTimeout(run,200);setTimeout(run,1000);setTimeout(run,2500);window.obiwanSyncProductGalleryToColor=syncGalleryToColor;
})();


/* OBIWAN_ASSET_SWATCH_GALLERY_RELATED_20260502: sync product color swatches to matching gallery mockups and top up related grid if Liquid/browser cache lags. */
(function(){
  if (window.__obiwanAssetSwatchGalleryRelated20260502) return;
  window.__obiwanAssetSwatchGalleryRelated20260502 = true;
  var banned=['dilf-damn-i-love-fire-t-shirt','14-hours-afraid-of-commitment-t-shirt','brisket-worth-losing-sleep-t-shirt','i-turn-dead-animals-into-art-t-shirt','if-god-didnt-want-us-to-eat-whole-hog-t-shirt','itll-be-done-t-shirt','adulting-is-hard-t-shirt','alarm-set-3am-on-purpose-t-shirt-1'];
  function norm(s){return (s||'').toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,' ').trim();}
  function handleFromHref(h){var m=(h||'').match(/\/products\/([^?/#]+)/);return m&&m[1];}
  function isColor(i){if(!i||i.type!=='radio')return false;var fs=i.closest('fieldset'),leg=fs&&fs.querySelector('legend,.form__label');return norm(i.name).indexOf('color')>-1||norm(leg&&leg.textContent).indexOf('color')>-1;}
  function activeAltCandidates(){return Array.from(document.querySelectorAll('media-gallery img,.product__media img,button.thumbnail img,.thumbnail-list img'));}
  function sync(color){var c=norm(color);if(!c)return false;var buttons=Array.from(document.querySelectorAll('button.thumbnail,.thumbnail-list button,media-gallery button[aria-controls],slider-component button[aria-controls]'));var hit=buttons.find(function(btn){var img=btn.querySelector('img');var a=norm(img&&img.alt);return a.endsWith(' '+c)||a.indexOf(c)>-1;});if(hit){hit.click();return true;}var img=activeAltCandidates().find(function(i){return norm(i.alt).indexOf(c)>-1;});var slide=img&&img.closest('[id^="Slide-"]');var id=slide&&slide.id;var b=id&&document.querySelector('button[aria-controls="'+CSS.escape(id)+'"]');if(b){b.click();return true;}return false;}
  function root(){var h=Array.from(document.querySelectorAll('h1,h2,h3')).find(function(x){return (x.textContent||'').indexOf('More Pitmaster Worthy Shirts')>-1 || (x.textContent||'').indexOf('Pitmasters Also Bought')>-1;});return h&&(h.closest('product-recommendations,.shopify-section,section')||h.parentElement);}
  function card(p){var img=p.images&&p.images[0]?p.images[0].src:'';var price=p.variants&&p.variants[0]?p.variants[0].price:'29.99';return '<li class="grid__item obiwan-related-fill"><div class="card-wrapper product-card-wrapper underline-links-hover"><div class="card card--standard card--media"><div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;"><div class="card__media"><div class="media media--transparent media--hover-effect">'+(img?'<img src="'+img+'" alt="'+p.title.replace(/"/g,'&quot;')+'" loading="lazy" width="533" height="533">':'')+'</div></div></div><div class="card__content"><div class="card__information"><h3 class="card__heading h5"><a href="/products/'+p.handle+'" class="full-unstyled-link">'+p.title+'</a></h3><div class="card-information"><div class="price"><div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span><span class="price-item price-item--regular">From $'+price+'</span></div></div></div></div></div></div></div></div></li>';}
  function fixRelated(){var r=root();if(!r)return;var g=r.querySelector('ul.grid,.product-grid');if(!g)return;var cur=handleFromHref(location.pathname)||'';Array.from(g.querySelectorAll('li.grid__item')).forEach(function(li){var h=handleFromHref((li.querySelector('a[href*="/products/"]')||{}).href);if(!h||h===cur||banned.indexOf(h)>-1)li.remove();});if(g.querySelectorAll('li.grid__item a[href*="/products/"]').length>=6)return;fetch('/collections/all-products-2/products.json?limit=250').then(function(x){return x.json();}).then(function(d){var used={};Array.from(g.querySelectorAll('a[href*="/products/"]')).forEach(function(a){var h=handleFromHref(a.href);if(h)used[h]=true;});(d.products||[]).some(function(p){if(g.querySelectorAll('li.grid__item a[href*="/products/"]').length>=6)return true;if(!p||!p.handle||p.handle===cur||used[p.handle]||banned.indexOf(p.handle)>-1)return false;used[p.handle]=true;g.insertAdjacentHTML('beforeend',card(p));return false;});}).catch(function(){});}
  document.addEventListener('change',function(e){if(isColor(e.target)&&e.target.checked)setTimeout(function(){sync(e.target.value);},80);},true);
  document.addEventListener('click',function(e){var lab=e.target.closest&&e.target.closest('label[for]');if(lab){var i=document.getElementById(lab.getAttribute('for'));if(isColor(i))setTimeout(function(){sync(i.value);},120);}},true);
  function run(){ /* 20260617: disabled old related-grid top-up to stop mobile sixth-card flicker. */ }
  document.addEventListener('DOMContentLoaded',run);setTimeout(run,250);setTimeout(run,1000);setTimeout(run,2500);
  window.obiwanSyncProductGalleryToColor=sync;
})();


/* OBIWAN_LOAD_CAROUSEL_VARIANT_SYNC_20260530: ensure existing carousel-variant-sync.js runs on live product pages. */
(function(){
  if (window.__bbqCarouselVariantSyncV3 || window.__obiwanCarouselVariantSyncLoader20260530) return;
  window.__obiwanCarouselVariantSyncLoader20260530 = true;
  var s = document.createElement('script');
  s.src = '/cdn/shop/t/2/assets/carousel-variant-sync.js?v=999999999999';
  s.defer = true;
  document.head.appendChild(s);
})();

/* OBIWAN_PDP_BESTSELLER_RECS_20260617_REMOVED_20260617: removed JS grid rebuild; Liquid section owns sale-price cards. */




/* ===== swipe->color sync (moved from asset) ===== */
/* LUKE 20260819 v4 — SAFE swipe->color sync, timing-robust.
   Detects the gallery image currently in view (IntersectionObserver + document-capture
   scroll/touch), maps alt->color, and if it differs from the checked color, CLICKS that
   color's label (drives the correct Dawn chain -> button AND cart both follow). Loop-guarded. */
(function(){
  if (window.__bbqGalleryColorSyncSafe20260819) return;
  window.__bbqGalleryColorSyncSafe20260819 = true;
  function norm(s){ return (s||'').toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,' ').trim(); }
  function colorFieldset(){
    return Array.prototype.slice.call(document.querySelectorAll('variant-selects fieldset, fieldset.product-form__input, .product-form__input')).find(function(fs){
      var l=fs.querySelector('legend,.form__label'); return /color/i.test((l&&l.textContent)||'');
    });
  }
  function colorInputs(){ var fs=colorFieldset(); return fs?Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')):[]; }
  function checkedColor(){ var r=colorInputs().find(function(i){return i.checked;}); return r&&r.value; }
  function colorFromAlt(alt){
    alt=(alt||'').trim(); if(!alt) return null;
    var vals=colorInputs().map(function(i){return i.value;}).sort(function(a,b){return b.length-a.length;});
    var suffix = alt.indexOf(' - ')>-1 ? alt.split(' - ').pop().trim() : alt;
    var v=vals.find(function(x){return norm(suffix)===norm(x);}); if(v) return v;
    return vals.find(function(x){return norm(alt).indexOf(norm(x))>-1;}) || null;
  }
  function galleryBox(){
    var g=document.querySelector('media-gallery, [id^="MediaGallery"], .product__media-wrapper, .product__media-list');
    return g ? g.getBoundingClientRect() : null;
  }
  function mainImgs(){
    return Array.prototype.slice.call(document.querySelectorAll('media-gallery img[alt], .product__media-item img[alt], .product__media-list img[alt], .product__media img[alt]'))
      .filter(function(im){ var r=im.getBoundingClientRect(); return r.width>60 && r.height>60; });
  }
  function centeredImg(){
    var gb=galleryBox(); if(!gb) return null; var gc=gb.left+gb.width/2, best=null, bd=1e9;
    mainImgs().forEach(function(im){
      var r=im.getBoundingClientRect();
      if(r.right<gb.left-5||r.left>gb.right+5) return;         // must overlap the gallery viewport
      var d=Math.abs((r.left+r.width/2)-gc); if(d<bd){bd=d;best=im;}
    });
    return best;
  }
  var busy=false, t=null;
  function sync(){
    if(busy) return;
    var img=centeredImg(); if(!img) return;
    var color=colorFromAlt(img.getAttribute('alt')); if(!color) return;
    if(norm(color)===norm(checkedColor())) return;             // matches -> no loop
    var input=colorInputs().find(function(i){return norm(i.value)===norm(color);});
    if(!input || input.checked) return;
    busy=true;
    var esc=(window.CSS&&CSS.escape)?CSS.escape(input.id):input.id;
    var label=document.querySelector('label[for="'+esc+'"]');
    (label||input).click();
    setTimeout(function(){ busy=false; sync(); }, 650);         // re-check after settle
  }
  function schedule(){ clearTimeout(t); t=setTimeout(sync, 130); }
  // Robust triggers — independent of when the gallery loads:
  document.addEventListener('scroll', schedule, true);          // capture catches inner scroll containers
  document.addEventListener('slideChanged', schedule, true);
  document.addEventListener('touchend', schedule, true);
  window.addEventListener('load', schedule);
  // IntersectionObserver backstop: fire when a slide becomes majority-visible (the one swiped to)
  var io=null, seen=new WeakSet(), tries=0;
  function wire(){
    var imgs=mainImgs();
    if(imgs.length){
      if(!io) io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting && e.intersectionRatio>=0.55) schedule(); }); }, {threshold:[0.55,0.8]});
      imgs.forEach(function(im){ if(!seen.has(im)){ seen.add(im); io.observe(im); } });
    }
    if(++tries<60) setTimeout(wire, 400);                       // keep wiring as gallery hydrates
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', wire); else wire();
  // POLL fallback: real-device swipes may not fire scroll/IO reliably; check centered slide periodically.
  var lastPolled=null;
  setInterval(function(){ try{ var im=centeredImg(); var a=im&&im.getAttribute('alt'); if(a && a!==lastPolled){ lastPolled=a; schedule(); } }catch(e){} }, 400);
})();


/* ===== cart-thumbnail override (moved from asset) ===== */
/* LUKE 20260820 v2 — CART-ONLY color thumbnail override. Strictly cart-scoped:
   rewrites ONLY the line-item <img> in the cart drawer / cart page to the chosen
   color's product image. Fail-safe (try/catch, no-op on miss). Never touches the
   PDP gallery, variant selection, or checkout. Observes ONLY cart-drawer nodes. */
(function(){
  if (window.__bbqCartColorThumb20260820) return;
  window.__bbqCartColorThumb20260820 = true;
  var mediaCache = {};
  function norm(s){ return (s||'').toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,' ').trim(); }
  async function colorMap(handle){
    if (mediaCache[handle]) return mediaCache[handle];
    try{
      var p = await (await fetch('/products/'+handle+'.js')).json();
      var map = {};
      (p.media||[]).forEach(function(m){
        var alt=m.alt||''; var src=(m.src||(m.preview_image&&m.preview_image.src)||'');
        if(!src) return;
        var suf = alt.indexOf(' - ')>-1 ? alt.split(' - ').pop().trim() : alt;
        if(suf && !map[norm(suf)]) map[norm(suf)] = src;
      });
      mediaCache[handle] = map; return map;
    }catch(e){ return {}; }
  }
  var running=false;
  async function fix(){
    if(running) return; running=true;
    try{
      var items = (await (await fetch('/cart.js')).json()).items || [];
      var rows = Array.prototype.slice.call(document.querySelectorAll(
        'cart-drawer .cart-item, .cart-drawer .cart-item, .cart-items .cart-item, tr.cart-item, .cart-item'));
      for (var i=0;i<items.length;i++){
        var it=items[i], row=rows[i]; if(!row) continue;
        var color=(it.options_with_values||[]).filter(function(o){return /colou?r/i.test(o.name);}).map(function(o){return o.value;})[0];
        if(!color) continue;
        var map=await colorMap(it.handle); var url=map[norm(color)]; if(!url) continue;
        var img=row.querySelector('img'); if(!img) continue;
        if((img.getAttribute('src')||'').indexOf(url.replace(/^https?:/,'').split('?')[0])===-1){
          img.setAttribute('src', url); img.removeAttribute('srcset');
        }
      }
    }catch(e){}
    running=false;
  }
  var t=null; function schedule(){ clearTimeout(t); t=setTimeout(fix,150); }
  // triggers: cart drawer opens / cart updates — scoped, not page-wide
  document.addEventListener('cart:refresh', schedule, true);
  document.addEventListener('click', function(e){
    var el=e.target.closest && e.target.closest('#cart-icon-bubble, a[href$="/cart"], a[href*="/cart?"], button[name="add"], .quantity__button, cart-drawer, .cart-remove-button');
    if(el) schedule();
  }, true);
  // observe ONLY the cart drawer/items container for re-renders
  function observeCart(){
    var c=document.querySelector('cart-drawer, .cart-drawer, cart-items, .cart-items');
    if(c && !c.__bbqCartObserved){ c.__bbqCartObserved=true; new MutationObserver(schedule).observe(c,{childList:true,subtree:true}); }
    return !!c;
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){observeCart();schedule();});
  else { observeCart(); schedule(); }
  // in case cart-drawer hydrates late, retry wiring briefly
  var tries=0, iv=setInterval(function(){ if(observeCart()||++tries>20) clearInterval(iv); },500);
})();
